module.exports = __webpack_public_path__ + "static/media/tangeebl-bg.1841c8a0.jpg";